import { gql } from '@apollo/client';

export const FARM_GQL = gql`
  query FarmDataQuery {
    farm(order_by: { name: asc }, where: { deleted_at: { _is_null: true } }) {
      id
      name
    }
  }
`;

export const LARGEST_FEEDFRAMES_QUERY = gql`
  query LargestFeedframesQuery(
    $analysisWhere: feed_frame_analysis_bool_exp!
    $limit: Int
    $orderBy: [feed_frame_analysis_order_by!]!
  ) {
    feed_frame_analysis(where: $analysisWhere, limit: $limit, order_by: $orderBy) {
      mass_moved_in_grams
      feed_frame {
        id
        started_at
        ended_at
        deleted_at
        feed_line {
          id
          name
          farm {
            id
            name
          }
        }
      }
    }
  }
`;

export const LARGEST_FEEDFRAMES_BY_DURATION_QUERY = gql`
  query LargestFeedframesByDurationQuery(
    $feedFrameWhere: feed_frame_bool_exp!
    $analysisWhere: feed_frame_analysis_bool_exp!
    $limit: Int
    $orderBy: [feed_frame_order_by!]!
  ) {
    feed_frame(where: $feedFrameWhere, limit: $limit, order_by: $orderBy) {
      id
      started_at
      ended_at
      deleted_at
      feed_line {
        id
        name
        farm {
          id
          name
        }
      }
      feed_frame_analyses(limit: 1, order_by: { created_at: desc_nulls_last }, where: $analysisWhere) {
        mass_moved_in_grams
      }
    }
  }
`;

export const FEEDERS_QUERY = gql`
  query FeedersQuery($feedLineIds: [uuid!]!) {
    feeder(where: { feed_line_id: { _in: $feedLineIds }, deleted_at: { _is_null: true } }) {
      id
      capacity_in_grams
      quantity
      feed_line_id
    }
  }
`;

export const FEED_FRAME_NOTES_QUERY = gql`
  query FeedFrameNotesQuery($feedFrameIds: [uuid!]!) {
    feed_frame_note(
      where: { feed_frame_id: { _in: $feedFrameIds }, deleted_at: { _is_null: true } }
      order_by: { created_at: desc }
    ) {
      feed_frame_id
      created_at
      feed_frame_category {
        id
        name
        description
      }
    }
  }
`;
